import { trackThemeToggle, trackGPTButtonClick } from "../utils/analytics";
import { AdjustmentsHorizontalIcon } from "@heroicons/react/20/solid";

function AppHeader({ darkMode, setDarkMode, onConfigClick, promptPreview }) {
  function toggleTheme() {
    const newTheme = !darkMode;
    setDarkMode(newTheme);
    trackThemeToggle(newTheme ? "dark" : "light");
  }

  return (
    <div className="fixed max-w-[900px] mx-auto top-0 left-0 right-0 p-2 sm:p-4 flex justify-between items-center z-50">
      <div className="flex items-center gap-2 sm:gap-4">
        <a
          href="https://chatgpt.com/g/g-uefFoRnpX"
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => trackGPTButtonClick()}
          className="flex items-center gap-2 px-2 sm:px-3 py-1.5 sm:py-2 
            bg-gradient-to-r from-teal-500/10 to-teal-600/10 dark:from-teal-500/20 dark:to-teal-400/20
            hover:from-teal-500/20 hover:to-teal-600/20 dark:hover:from-teal-500/30 dark:hover:to-teal-400/30
            border border-teal-200/30 dark:border-teal-400/20
            rounded-full shadow-sm backdrop-blur-sm
            transform hover:scale-105 transition-all duration-300
            print:hidden"
        >
          <img
            src="/logo.png"
            alt="Logo"
            className="w-5 h-5 sm:w-6 sm:h-6 rounded-full"
          />
          <span className="text-gray-700 dark:text-gray-200 font-medium text-sm sm:text-base hidden sm:inline">
            Summarizer GPT
          </span>
        </a>
      </div>

      <div className="flex items-center gap-2 sm:gap-4">
        <div className="relative group">
          <button
            onClick={onConfigClick}
            className="p-1.5 sm:p-2 px-2 sm:px-3 rounded-lg bg-white dark:bg-gray-700 
              hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors print:hidden
              flex items-center gap-1 sm:gap-2"
          >
            <AdjustmentsHorizontalIcon className="w-5 h-5 text-gray-700 dark:text-gray-300" />
            <span className="text-sm sm:text-md text-gray-700 dark:text-gray-300 font-medium hidden sm:inline">
              Configure GPT
            </span>
          </button>

          {/* Preview Overlay */}
          <div className="absolute right-0 top-full mt-2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-200">
            {promptPreview}
          </div>
        </div>

        <button
          onClick={toggleTheme}
          className="p-1.5 sm:p-2 rounded-lg bg-white dark:bg-gray-700 
            hover:bg-gray-200 dark:hover:bg-gray-600 transition-colors print:hidden"
          aria-label="Toggle theme"
        >
          {darkMode ? (
            <svg
              className="w-5 h-5 sm:w-6 sm:h-6 text-amber-500"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M20.354 15.354A9 9 0 018.646 3.646 9.003 9.003 0 0012 21a9.003 9.003 0 008.354-5.646z"
              />
            </svg>
          ) : (
            <svg
              className="w-5 h-5 sm:w-6 sm:h-6 text-gray-700 dark:text-gray-300"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M12 3v1m0 16v1m9-9h-1M4 12H3m15.364 6.364l-.707-.707M6.343 6.343l-.707-.707m12.728 0l-.707.707M6.343 17.657l-.707.707M16 12a4 4 0 11-8 0 4 4 0 018 0z"
              />
            </svg>
          )}
        </button>
      </div>
    </div>
  );
}

export default AppHeader;
